<template>
	<div class="card">
		<div class="card-header bg-info text-white">Editor de alias</div>
		<div class="card-body">
			<div class="alert alert-warning" v-if="alias === 'nuevo'">
				Para crear un nuevo alias es necesario que introduzcas los datos del origen y al menos un destino
			</div>
			<h4>Origen</h4>
			<div class="form-group">
				<div class="input-group input-group-sm" v-if="!editarOrigen">
					<input type="text" class="form-control" v-model="alias.cuenta" disabled="true">
					<div class="input-group-append">
						<span class="input-group-text">@</span>
					</div>
					<select name="" id="" class="form-control" disabled="true" v-model="alias.dominio">
						<option :value="dominio.id" v-for="dominio in listadoDominios" :key="dominio.id">{{dominio.dominio}}</option>
					</select>
					<div class="input-group-append">
						<button class="btn btn-danger" @click="cambiarOrigen">
							<span class="fa fa-edit"></span>
						</button>
					</div>
				</div>

				<!-- SI ESTAMOS EDITANDO EL ORIGEN -->
				<div class="input-group input-group-sm" v-if="editarOrigen">
					<input type="text" class="form-control" v-model="datos.cuentaNew">
					<div class="input-group-append">
						<span class="input-group-text">@</span>
					</div>
					<select name="" id="" class="form-control" v-model="datos.dominioNew">
						<option :value="dominio.id" v-for="dominio in listadoDominios" :key="dominio.id">{{dominio.dominio}}</option>
					</select>
					<div class="input-group-append" v-if="alias !== 'nuevo'">
						<button class="btn btn-danger" @click="editarOrigen = false">
							<span class="fa fa-close mr-2"></span>
							Cancelar
						</button>
						<button class="btn btn-primary" @click="cambiarOrigen">
							<span class="fa fa-save mr-2"></span>
							Actualizar
						</button>
					</div>
				</div>

				<div class="text-right mt-3" v-if="alias !== 'nuevo'">
					<button class="btn btn-danger" @click="eliminar">
						<span class="fa fa-trash mr-2"></span>
						Eliminar alias por completo
					</button>
				</div>
			</div>
		</div>
		<div class="card-body bg-light">
			<div class="row">
				<div class="col text-left">
					<h4 v-if="alias !== 'nuevo'">Destinos</h4>
					<h4 v-if="alias === 'nuevo'">Destino</h4>
				</div>
				<div class="col text-right">
					<button class="btn btn-sm btn-primary" @click="nuevoDestino" v-if="!nuevo">
						<span class="fa fa-plus mr-2"></span>
						Nuevo
					</button>
				</div>
			</div>
			<div class="input-group input-group-sm mt-2 mb-2" v-if="nuevo">
				<input type="text" class="form-control" v-model="nuevo.cuenta" placeholder="cuenta">
				<div class="input-group-append">
					<span class="input-group-text">@</span>
				</div>
				<select name="" id="" class="form-control" v-model="nuevo.dominio_destino">
					<option :value="dominio.id" v-for="dominio in listadoDominios" :key="dominio.id">{{dominio.dominio}}</option>
				</select>
				<div class="input-group-append" v-if="alias !== 'nuevo'">
					<button class="btn btn-primary" @click="addDestino">
						<span class="fa fa-save mr-2"></span>
						Guardar
					</button>
					<button class="btn btn-danger" @click="nuevo = null">
						<span class="fa fa-trash"></span>
					</button>
				</div>
			</div>
			<div class="input-group input-group-sm mb-2" v-for="cuenta in cuentas" :key="cuenta.email">
				<input type="text" class="form-control" disabled="true" :value="cuenta.destino">
				<div class="input-group-append">
					<span class="input-group-text">@</span>
				</div>
				<select name="" id="" class="form-control" v-model="cuenta.dominio_destino" disabled="true">
					<option :value="dominio.id" v-for="dominio in listadoDominios" :key="dominio.id">{{dominio.dominio}}</option>
				</select>
				<div class="input-group-append">
					<button class="btn btn-danger" @click="eliminarDestino(cuenta)">
						<span class="fa fa-trash"></span>
					</button>
				</div>
			</div>
		</div>
		<div class="card-footer" v-if="alias === 'nuevo'">
			<button class="btn btn-primary btn-sm" @click="crear">
				<span class="fa fa-save mr-2"></span>
				Crear alias
			</button>
		</div>
	</div>
</template>

<script>
import API from './api'
export default {
	props: ['alias'],

	watch: {
		alias: function (nuevo, anterior) {
			if (this.alias !== 'nuevo') {
				this.editarOrigen = false
				this.getAlias()
				this.cuentaOld = this.alias.cuenta
				this.dominioOld = this.alias.dominio
				this.nuevo = null
			} else {
				this.editarOrigen = true
				this.cuentas = []
				this.nuevo = {
					cuenta: '',
					dominio_destino: null
				}
			}
		}
	},

	created () {
		if (this.alias === 'nuevo') {
			this.editarOrigen = true
			this.cuentas = []
			this.nuevo = {
				cuenta: '',
				dominio_destino: null
			}
		} else {
			this.editarOrigen = false
			this.getAlias()
			this.cuentaOld = this.alias.cuenta
			this.dominioOld = this.alias.dominio
		}
		API.getDominios()
			.then(res => {
				this.listadoDominios = res.data.dominios
			})
			.catch(e => {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: e.response.data.error
				})
			})
	},

	data () {
		return {
			cuentas: [],
			datos: {
				cuentaOld: '',
				dominioOld: null,
				cuentaNew: '',
				dominioNew: null
			},
			nuevo: null,
			editarOrigen: false,
			listadoDominios: []
		}
	},

	methods: {
		nuevoDestino () {
			this.nuevo = {
				cuenta: '',
				dominio_destino: null
			}
		},
		getAlias () {
			API.getAlias(this.alias.cuenta, this.alias.dominio)
				.then(res => {
					this.cuentas = res.data.alias
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cambiarOrigen () {
			this.datos.cuentaNew = this.alias.cuenta.toString()
			this.datos.dominioNew = this.alias.dominio + 0
			this.editarOrigen = true
		},

		crear () {
			const datos = {
				cuenta_origen: this.datos.cuentaNew,
				dominio_origen: this.datos.dominioNew,
				cuenta_destino: this.nuevo.cuenta,
				dominio_destino: this.nuevo.dominio_destino
			}
			API.setAlias(datos)
				.then(res => {
					this.$emit('update:alias', res.data.alias)
					this.getAlias()
					this.getDominios()
					this.nuevo = null
					this.editarOrigen = false
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		addDestino () {
			const datos = {
				cuenta_origen: this.alias.cuenta,
				dominio_origen: this.alias.dominio,
				cuenta_destino: this.nuevo.cuenta,
				dominio_destino: this.nuevo.dominio_destino
			}
			API.setAlias(datos)
				.then(res => {
					this.$emit('update:alias', res.data.alias)
					this.getAlias()
					this.getDominios()
					this.nuevo = null
					this.editarOrigen = false
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		eliminar () {
			// Vamos a eliminar el alias y todos sus destinos
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar alias',
				mensaje: `¿Quieres eliminar este alias y todos sus destinos?`,
				callback: (acepta) => {
					if (acepta) {
						API.eliminarAlias(this.alias)
							.then(res => {
								this.$emit('update')
								this.$emit('update:alias', null)
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},

		eliminarDestino (destino) {
			const eliminaTodo = (this.cuentas.length === 1)

			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar destino',
				mensaje: '¿Quieres eliminar este destino del alias?',
				callback: (acepta) => {
					if (acepta) {
						API.delAlias(destino)
							.then(res => {
								if (eliminaTodo) {
									this.$emit('update')
									this.$emit('update:alias', null)
								} else {
									this.getAlias()
								}
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/gestion-cuentas-email/vue/editor-alias.vue